import React, { useEffect, useState } from "react";
import '../../../CSS/Areas.css'
import {BsPlus} from "react-icons/bs";
import { FaArrowLeftLong } from "react-icons/fa6";
import {getPermission} from '../../../Conexiones/Conexion';
import { getApi, postApi, putApi, deleteApi } from "../../../Conexiones/Models"; 
import { useNavigate } from "react-router";
import CloseButton from 'react-bootstrap/CloseButton';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from "../../../Utils/AlertMessage";
import Loading from '../../../Utils/Loading';

function Adicionales(){
    const navigate = useNavigate();
    const [adicionales, setAdicionales] = useState([]);
    const [tablaAdicionales, setTablaAdicionales] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'adicionales/';
    const [isLoading,setIsLoading]=useState(false);

    useEffect( ()=>{
        const getAdicionales = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,1);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setAdicionales(res.data);
                        setTablaAdicionales(res.data);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else if(permiso === 210){
                navigate('/');
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        }
        getAdicionales();
    },[idUsuario,navigate])

    const getAllAdicionales = async () =>{
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setAdicionales(res.data);
                setTablaAdicionales(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    
    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaAdicionales.filter((elemento)=> {
            if  (elemento.nombreAdicional.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda;
        })
        setAdicionales(resBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos')
    }

    const modalDelete = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTE ADICIONAL?')
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="¡Registro eliminado correctamente!"){
                        getAllAdicionales();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    /* Agregar Adicional */
    const [showGasAdic, setShowGasAdic] = useState(false);
    const [nombre, setNombre] = useState('')
    const handleCloseAdicional = () => {
        setShowGasAdic(false);
        setNombre('');
    }
    const handleShowAdicional = () =>{
        setShowGasAdic(true);
    }
    const save = async (e) =>{
        e.preventDefault()
        if(nombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri;
            const data = {nombreAdicional:nombre};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleCloseAdicional();
                    getAllAdicionales();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
    }

    /* Editar adicional */
    const [showUpdAdi, setShowUpdAdi] = useState(false);
    const [idAdi, setIdAdi] = useState('');
    const handleCloseUpdAdicional = () => {
        setShowUpdAdi(false);
        setIdAdi('');
        setNombre('');
    }
    const handleShowUpdAdicional = (idA,nameA) =>{
        const id = idA;
        const name = nameA;
        setIdAdi(id);
        setNombre(name)
        setShowUpdAdi(true);
    }

    const update = async (e) =>{
        e.preventDefault()
        if(nombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri + idAdi;
            const data = {nombreAdicional:nombre};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro actualizado correctamente!"){
                    handleCloseUpdAdicional();
                    getAllAdicionales();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
    }

    return(
        <div className="areas">
            {
                isLoading ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label>GESTIÓN DE ADICIONALES</label>
                    </div>
                    <div className='divbotonA' >                                                                                             
                        <div className='botonA' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={handleShowAdicional} type="button">
                                <label className="agregar">ADICIONAL</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>                    
                        </div>
                    </div>
                    {adicionales.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                        <div className="tabla-cajaA" >
                            <div className="table tabla">
                                <table className="table table-hover table-bordered text-uppercase">
                                    <thead className="encabezado">
                                        <tr >                                
                                            <th>ADICIONAL</th>
                                            <th style={{width:'50%'}}>ACCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {adicionales.map(adicional =>{
                                            return(                                    
                                                <tr key={adicional.idAdicional}>                                       
                                                    <td valign="middle">{adicional.nombreAdicional}</td>
                                                    <td>
                                                        <div>
                                                            <div className="btn iconoH" onClick={() => handleShowUpdAdicional(adicional.idAdicional,adicional.nombreAdicional)} style={{margin:'5px'}}>
                                                                <span className="bi bi-pen" title="EDITAR"></span>
                                                            </div>
                                                            <div className="btn iconoH" style={{margin:'5px'}} onClick={() => modalDelete(adicional.idAdicional)}>
                                                                <span className="bi bi-trash" title="ELIMINAR"></span>
                                                            </div>                                     
                                                        </div>
                                                    </td>                                                                                                
                                                </tr>                                                                        
                                            )
                                        })}                        
                                    </tbody>
                                </table>
                            </div>      
                        </div>
                    )}

                    {/*AGREGAR ADICIONAL*/}
                    <Modal  show={showGasAdic}  onHide={handleCloseAdicional}  id="modal-agregar-adicional" >
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR ADICIONAL</Modal.Title>
                            <CloseButton onClick={handleCloseAdicional} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left', marginTop:'15px'}}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control" value={nombre} id="exampleFormControlInput1" required 
                                    onChange={e => setNombre(e.target.value) }/>
                                </div>             
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary"  onClick={handleCloseAdicional} >CANCELAR</Button>
                            <Button type="button" className="btn btn-light btncolor" onClick={save} >ACEPTAR</Button>
                        </Modal.Footer>
                    </Modal>

                    {/*EDITAR ADICIONAL*/}
                    <Modal  show={showUpdAdi}  onHide={handleCloseUpdAdicional}  id="modal-editar-adicional" >
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR ADICIONAL</Modal.Title>
                            <CloseButton onClick={handleCloseUpdAdicional} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left', marginTop:'15px'}}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control" value={nombre} id="exampleFormControlInput1" required 
                                    onChange={e => setNombre(e.target.value) }/>
                                </div>             
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary"  onClick={handleCloseUpdAdicional} >CANCELAR</Button>
                            <Button type="button" className="btn btn-light btncolor" onClick={update} >ACEPTAR</Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default Adicionales;